import React from 'react';

const LanguageSwitcher = ({ language = 'en', setLanguage = () => {} }) => (
  <div className="language-switcher" style={{ position: 'fixed', top: '1rem', right: '1rem', zIndex: 1000 }}>
    <select
      value={language}
      onChange={(e) => setLanguage(e.target.value)}
      className="language-select"
      style={{
        padding: '0.5rem 1rem',
        borderRadius: '50px',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        background: '#fff',
        fontSize: '0.875rem',
        cursor: 'pointer',
      }}
    >
      <option value="en">🇬🇧 EN</option>
      <option value="sv">🇸🇪 SV</option>
    </select>
  </div>
);

export default LanguageSwitcher;